import type { AbcVerteilung, PdpBlockZahlen, PdpDetails, PdpGap } from '@awf/shared';

export type BlockSchluessel =
  'keywords' | 'ueberschriften' | 'entities' | 'inhalte' | 'usps' | 'faq';

/** Die sechs Bloecke aus Martins Formular, in seiner Reihenfolge. */
export const PDP_BLOECKE: readonly {
  schluessel: BlockSchluessel;
  nummer: number;
  titel: string;
  kurz: string;
}[] = [
  { schluessel: 'keywords', nummer: 1, titel: 'Keyword-Abdeckung', kurz: 'Keywords' },
  { schluessel: 'ueberschriften', nummer: 2, titel: 'H-Struktur', kurz: 'H-Struktur' },
  { schluessel: 'entities', nummer: 3, titel: 'Terme & Entities', kurz: 'Entities' },
  { schluessel: 'inhalte', nummer: 4, titel: 'Content-Gaps', kurz: 'Content-Gaps' },
  { schluessel: 'usps', nummer: 5, titel: 'Ungenutzte USPs', kurz: 'USPs' },
  { schluessel: 'faq', nummer: 6, titel: 'Empfohlene FAQs', kurz: 'FAQ' },
];

function verteilung(liste: PdpGap[]): AbcVerteilung {
  const v = { a: 0, b: 0, c: 0 };
  for (const g of liste) {
    if (g.klasse === 'A') v.a++;
    else if (g.klasse === 'B') v.b++;
    else if (g.klasse === 'C') v.c++;
  }
  return v;
}

/** Sobald die Details da sind, zaehlen sie -- `befund.bloecke` ist nur der Stand aus Firestore. */
export function zahlenAusDetails(d: PdpDetails): PdpBlockZahlen {
  return {
    keywords: d.keywords.length,
    ueberschriften: d.ueberschriften.length,
    entities: d.entities.length,
    inhalte: d.inhalte.length,
    usps: d.usps.offen.length + d.usps.platziert.length + d.usps.schwach.length,
    faq: d.faq.length,
    klassen: {
      keywords: verteilung(d.keywords),
      entities: verteilung(d.entities),
      inhalte: verteilung(d.inhalte),
    },
  };
}

export function verteilungText(v?: AbcVerteilung): string {
  if (!v) return '';
  return (
    [
      ['A', v.a],
      ['B', v.b],
      ['C', v.c],
    ] as const
  )
    .filter(([, n]) => n > 0)
    .map(([k, n]) => `${n}×${k}`)
    .join(' · ');
}
